import React,{lazy} from "react";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import * as ReactDOMClient from 'react-dom/client';

import "./i18n";
import { HelmetProvider } from "react-helmet-async";
const App = lazy(() => import("./App"));
const Seo = lazy(() => import("./Seo"));



const helmetContext = {};
const root = ReactDOMClient.createRoot(document.getElementById('root'));
root.render(
 <React.StrictMode>
   <BrowserRouter>
   <HelmetProvider context={helmetContext}>
      <Seo />
       <App />
  </HelmetProvider>
   </BrowserRouter>
 </React.StrictMode>
);
reportWebVitals();
